var map = {
	"./de/warrior-name.png": "WPII",
	"./en/warrior-name.png": "fvW7",
	"./es/warrior-name.png": "VKPg",
	"./fr/warrior-name.png": "gz1m",
	"./ja/warrior-name.png": "BoUp",
	"./ko/warrior-name.png": "avyw",
	"./pt/warrior-name.png": "1MR2",
	"./ru/warrior-name.png": "Wkn3",
	"./th/warrior-name.png": "+6kZ",
	"./zh-Hant/warrior-name.png": "iP+M"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "y0Sb";